import React from 'react'
import notFoundImg from '../../assets/images/404@2x.png'

function NotFoundPage() {
  return (
   
      <div>
      <div className='img-center-page'>
        <img src={notFoundImg} />
      </div>
      <div class="btn-fix-btm">
        {/* <button class="drk-blue-btn">Back to Home</button> */}
      </div>
    </div>
    
  )
}

export default NotFoundPage